// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__f8PHc","list":"PatternAutocomplete_list__2il3f"};